import Groupings from "../Groupings.js";
import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class ComponentOptionsGrouping {

    /** @type {function()} */
    #refreshFunction;
    /** @type {Grouping|null} */
    #grouping;

    /**
     *
     * @param refreshFunction {function()}
     */
    constructor(refreshFunction) {
        this.#refreshFunction = refreshFunction;
        this.#grouping = Groupings.GROUP_BY_MONTH;
    }

    createNode() {
        const short = window.innerWidth < 800;

        const noGroupingButton = DomBuilder.element('input', { type: 'radio', name: 'options', class: 'btn-check', id: 'grouping-off' });
        const monthButton = DomBuilder.element('input', { type: 'radio', name: 'options', class: 'btn-check', id: 'grouping-month', checked: true });
        const yearButton = DomBuilder.element('input', { type: 'radio', name: 'options', class: 'btn-check', id: 'grouping-year' });
        const allButton = DomBuilder.element('input', { type: 'radio', name: 'options', class: 'btn-check', id: 'grouping-all' });

        const noGroupingLabel = DomBuilder.element('label', { class: 'btn btn-secondary', for: 'grouping-off' }, short ? "Ø" : "No grouping");
        const monthLabel = DomBuilder.element('label', { class: 'btn btn-secondary', for: 'grouping-month' }, "Month");
        const yearLabel = DomBuilder.element('label', { class: 'btn btn-secondary', for: 'grouping-year' }, "Year");
        const allLabel = DomBuilder.element('label', { class: 'btn btn-secondary', for: 'grouping-all' }, "Σ");

        noGroupingButton.addEventListener('change', () => {
            this.#grouping = Groupings.NO_GROUPING;
            this.#refreshFunction();
        });
        monthButton.addEventListener('change', () => {
            this.#grouping = Groupings.GROUP_BY_MONTH;
            this.#refreshFunction();
        });
        yearButton.addEventListener('change', () => {
            this.#grouping = Groupings.GROUP_BY_YEAR;
            this.#refreshFunction();
        });
        allButton.addEventListener('change', () => {
            this.#grouping = Groupings.GROUP_ALL;
            this.#refreshFunction();
        });

        return DomBuilder.div({ class: 'btn-group grouping-component', role: 'group' }, [
            noGroupingButton, noGroupingLabel,
            monthButton, monthLabel,
            yearButton, yearLabel,
            allButton, allLabel
        ]);
    }

    getGrouping() {
        return this.#grouping;
    }
}
